export const ROOT_CLASSNAME = 'ActionButton';
export const ICON_CLASSNAME = `${ROOT_CLASSNAME}__icon`;
